// CourseCards.jsx
import React, { useState, useEffect } from 'react';
import { CourseService } from '../services/course.service';

export default function CourseCards() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        setLoading(true);
        const data = await CourseService.getAllCourses();
        setCourses(data.courses.slice(0, 3)); // トップ3コースのみ表示
      } catch (error) {
        console.error('コース取得エラー:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  const getCourseCardClass = (index) => {
    const classes = ['blue', 'green', 'pink'];
    return classes[index % classes.length];
  };

  const getCourseIcon = (course, index) => {
    if (course.thumbnail_url) {
      return course.thumbnail_url;
    }
    const icons = ['/first.png', '/second.png', '/third.png'];
    return icons[index % icons.length];
  };

  if (loading) {
    return (
      <div className="course-cards">
        <div className="course-cards-loading">
          <div className="loading-skeleton"></div>
          <div className="loading-skeleton"></div>
          <div className="loading-skeleton"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="course-cards">
      {courses.map((course, index) => (
        <div key={course.id} className={`course-card ${getCourseCardClass(index)}`}>
          <div className="icon-circle">
            <img src={getCourseIcon(course, index)} alt={`${course.title}アイコン`} />
          </div>
          <h3>{course.title}</h3>
          <div className="course-info">
            <div><img src="/note.png" alt="ノート" /> {course.lesson_count}</div>
            <span className="divider"></span>
            <div><img src="/videos.png" alt="動画" /> {course.video_count}</div>
            <span className="divider"></span>
            <div><img src="/people-2.png" alt="人" /> {course.enrolled_count}</div>
          </div>
        </div>
      ))}
    </div>
  );
}